/* ==========================================================================
   PRODUCT CARD — Multi-image hover navigation
   --------------------------------------------------------------------------
   - Click arrows: cycle through all product images, locks state until reset
   - Mouse leaves card: state resets to first image
   ========================================================================== */

(function () {
  if (window.__productCardNavInit) return;
  window.__productCardNavInit = true;

  function setActiveImage(wrap, newIndex) {
    var images = wrap.querySelectorAll('.product-card__image');
    if (!images.length) return;

    var count = images.length;
    var index = ((newIndex % count) + count) % count;

    for (var i = 0; i < images.length; i++) {
      if (i === index) {
        images[i].classList.add('product-card__image--active');
      } else {
        images[i].classList.remove('product-card__image--active');
      }
    }

    wrap.setAttribute('data-current-image', String(index));
  }

  function resetCard(wrap) {
    if (!wrap) return;
    if (wrap.getAttribute('data-current-image') === '0') return;
    setActiveImage(wrap, 0);
  }

  function handleClick(event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var button = target.closest('.product-card__nav');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    var wrap = button.closest('.product-card__media-wrap');
    if (!wrap) return;

    var current = parseInt(wrap.getAttribute('data-current-image') || '0', 10);
    var direction = button.classList.contains('product-card__nav--next') ? 1 : -1;

    setActiveImage(wrap, current + direction);
  }

  // Capture phase to fire before any other handler (e.g. link prefetch, anchor nav)
  document.addEventListener('click', handleClick, true);
  document.addEventListener('pointerdown', handleClick, true);

  // Reset state when mouse leaves the card
  document.addEventListener('mouseout', function (event) {
    var card = event.target.closest && event.target.closest('.product-card');
    if (!card) return;
    if (card.contains(event.relatedTarget)) return;
    var wrap = card.querySelector('.product-card__media-wrap');
    resetCard(wrap);
  });
})();
